import { Selector } from '@ngxs/store';
import { ChatMessage } from '.';
import { Client } from '../../../features/bot/modules/bot-crm/store';
import { ChatStateModel, Suggestion } from './chat-state.model';
import { ChatState } from './chat.state';

export class ChatSelectors {
  @Selector([ChatState])
  static client(state: ChatStateModel): Client {
    return state.client;
  }
  @Selector([ChatState])
  static messages(state: ChatStateModel): ChatMessage[] {
    return state.messages;
  }
  @Selector([ChatState])
  static status(state: ChatStateModel): string {
    return state.status;
  }
  @Selector([ChatState])
  static infoMode(state: ChatStateModel): boolean {
    return state.infoMode;
  }
  @Selector([ChatState])
  static suggestions(state: ChatStateModel): Suggestion[] {
    return state.suggestions;
  }
}
